import { render, staticRenderFns } from "./viewField.vue?vue&type=template&id=99b13a4a&scoped=true"
import script from "./viewField.vue?vue&type=script&lang=js"
export * from "./viewField.vue?vue&type=script&lang=js"
import style0 from "./viewField.vue?vue&type=style&index=0&id=99b13a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b13a4a",
  null
  
)

export default component.exports